import { Bodytext, Heading } from '@acorns/web-components'
import styled from 'styled-components'

import theme, { style } from 'theme'

export const Container = styled.div<{ hasBorder?: boolean }>`
  width: 100%;
  ${(props) =>
    props.hasBorder &&
    `
     padding: 50px;
     border-top: 10px solid ${theme.colors.ivoryLight};
     @media (max-width: ${theme.breakpoints.sm}px) {
        padding: 50px 30px;
      }
    `};
`

export const GridContainer = styled.div<{
  isHeaderBelowGraph?: boolean
  mobilePadding?: number
}>`
  width: 100%;
  display: grid;
  /* Note: Allow each child to grow as much as they want with min widths of 290px (will wrap after)*/
  grid-template-columns: repeat(auto-fit, minmax(290px, auto));
  grid-column-gap: ${(props) => (props.isHeaderBelowGraph ? 30 : 80)}px;
  grid-area: auto;
  margin-left: ${(props) => (props.isHeaderBelowGraph ? 40 : 0)}px;

  @media (max-width: 880px) {
    margin-left: 0px;
    grid-column-gap: 40px;
    grid-template-columns: repeat(auto-fit, minmax(200px, auto));
  }
  @media (max-width: 660px) {
    grid-template-columns: repeat(auto-fit, minmax(290px, auto));
  }
  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    display: flex;
    flex-direction: column;
    background: ${(props) => props.theme.colors.white};
    margin-top: 10px;
    padding: 0;
  }
`

export const GridListHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`

export const GridListHeaderTitle = styled(Heading)`
  font-size: 22px;
  line-height: 30px;
`

export const GridListHeaderItemCount = styled(Bodytext)`
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  color: ${style((theme) => theme.colors.stone)};
`
